module.exports = __webpack_public_path__ + "static/flowerbed_chopped-f69cdf75642561d34037cb63e04dea37.png";